export const viewportHeight = () =>
  Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

export type UseFullHeightProps = {
  element: HTMLDivElement;
  defaultHeight: number;
  paddingBottom?: number;
};

export const getDistanceToViewportBottom = (element: HTMLElement): number => {
  const vh = viewportHeight();
  return vh - element.getBoundingClientRect().top;
};
